var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutcome5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F43E3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C14.486 10 10 14.486 10 20C10 25.514 14.486 30 20 30C25.514 30 30 25.514 30 20C30 14.486 25.514 10 20 10ZM23.493 16C24.317 16 24.986 16.669 24.986 17.493C24.986 18.317 24.317 18.986 23.493 18.986C22.669 18.986 22 18.317 22 17.493C22 16.669 22.669 16 23.493 16ZM16.5 16C17.328 16 18 16.672 18 17.5C18 18.328 17.328 19 16.5 19C15.672 19 15 18.328 15 17.5C15 16.672 15.672 16 16.5 16ZM20 26C15 26 14 21 14 21H26C26 21 25 26 20 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcome5);
export default __webpack_public_path__ + "static/media/outcome5.e48ba11b4697f3d2cc970e54320eb32c.svg";
export { ForwardRef as ReactComponent };